import { useEffect, useState } from 'react'

/** Keep in sync with the `max-width: 560px` blocks in the UI stylesheets. */
export const MOBILE_MEDIA_QUERY = '(max-width: 560px)'

const query = () => globalThis.matchMedia?.(MOBILE_MEDIA_QUERY)

export const isMobileLayout = () => query()?.matches ?? false

/** Mobile layout flag driven by the same breakpoint the CSS uses. */
export const useIsMobileLayout = () => {
  const [matches, setMatches] = useState(isMobileLayout)

  useEffect(() => {
    const mql = query()
    if (!mql) return
    const onChange = () => setMatches(mql.matches)
    onChange()
    mql.addEventListener('change', onChange)
    return () => mql.removeEventListener('change', onChange)
  }, [])

  return matches
}
